import React from 'react';
import Email from '../Email';
import tools from '../../lib/tools';

export default function RetornoConsensoOPS({ resp = {}, notify = false, print = false, viewHeader = false }) {

    const openURL = (error = false) => {
        return tools.openURL(`${resp.url}`);
    }

    return (
        <Email emailClass={`${print ? 'print-email' : 'email'}`}>
            <br />
            <br />
            <div className="w-100">
                <p className="text-center mt-30 mb-30 fb-18">RETORNO DO CONSENSO</p>
            </div>
            <p>Olá!</p>
            <p>Informamos que o profissional assistente acatou integral ou parcialmente o consenso referente ao processo ID {resp.protocolo} - {resp.beneficiario_nome} - {resp.beneficiario_guia}.</p>
            <p>Para consulta do retorno e visualização dos anexos, acesse a plataforma na aba “Comunicações Adicionais”.</p>
            <br />
            <p>Aguardamos o retorno na plataforma para prosseguimento do processo.</p>
            <br />
            <button className="btn btn-primary f700-16" onClick={openURL}>Visualizar processo</button>
            <br />
            <br />
            <div className="w-100 text-justify bold pb-50">
                <p>Atenciosamente,<br />
                    Equipe säästö.</p>
            </div>
        </Email>
    );
}